export const sortLabels = {
  'Data de inclusão': 'inclusionDate',
  'Nome completo': 'name',
  CPF: 'cpf',
  'E-mail': 'email',
};

export const listLabels = {
  'Data de inclusão': ['Mais recente', 'Mais antiga'],
  'Nome completo': ['A - Z', 'Z - A'],
  CPF: ['Crescente', 'Decrescente'],
  'E-mail': ['A - Z', 'Z - A'],
};
